<button type="button"
        mat-icon-button
        class="repair-menu-trigger"
        [matMenuTriggerFor]="menu"
        [matTooltip]="'SUPPORT_REPAIR.MENU_TOOLTIP' | translate"
        [disabled]="busy() !== null"
        [attr.aria-label]="'SUPPORT_REPAIR.MENU_TOOLTIP' | translate">
  @if (busy() !== null) {
    <mat-spinner diameter="16"></mat-spinner>
  } @else {
    <mat-icon>build</mat-icon>
  }
</button>

<mat-menu #menu="matMenu" class="repair-menu-panel">
  <button mat-menu-item type="button" (click)="onEditClick()">
    <mat-icon>edit</mat-icon>
    <span>{{ 'SUPPORT_REPAIR.EDIT' | translate }}</span>
  </button>

  <button mat-menu-item type="button" (click)="onUpdateClick()">
    <mat-icon>sync</mat-icon>
    <span>{{ 'SUPPORT_REPAIR.UPDATE' | translate }}</span>
  </button>

  <button mat-menu-item type="button" (click)="onReplaceClick()">
    <mat-icon>swap_horiz</mat-icon>
    <span>{{ 'SUPPORT_REPAIR.REPLACE' | translate }}</span>
  </button>
</mat-menu>
